"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var user_1 = require("Consts/user");
exports.default = (function (user) {
    if (!user || !user.roles)
        return false;
    return user.roles.some(function (role) {
        return role.name === user_1.UserRoles.expert ||
            role.name === user_1.UserRoles.provider ||
            role.parent_name === user_1.UserRoles.expert ||
            role.parent_name === user_1.UserRoles.provider;
    });
});
